var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaveTop2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 720,
    height: 116,
    viewBox: "0 0 720 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1275.06 -67.0928C1671.32 -67.0928 1628.26 78.1896 1985.58 78.1896C2136.2 35.659 2106.36 -155.546 2072.62 -245.831H685.488C110.267 -186.252 -949.289 -67.0928 -585.74 -67.0928C-131.305 -67.0928 -12.2371 115.771 345.539 115.771C703.316 115.771 878.806 -67.0928 1275.06 -67.0928Z",
    fill: "url(#paint0_linear_1237_1439)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1237_1439",
    x1: 926.015,
    y1: -87.9708,
    x2: 230.357,
    y2: -806.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15A0DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522513,
    stopColor: "#199BD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02628C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveTop2);
export default __webpack_public_path__ + "static/media/wave-top-2.dee3c35f6b7f83b5862f1e662e206038.svg";
export { ForwardRef as ReactComponent };